/**
 * Raiz da tela.
 *
 * Recebe direto `tabs` OU uma sequência de `panel` — tela sem abas é caminho
 * normal, não exceção (ver seção 1.1 do plano). No caminho antigo, tela sem aba
 * perdia tudo, porque os painéis eram pendurados em abas que não existiam.
 */
import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroup } from '@angular/forms';

import { ScreenNode } from '../../model/node-props';
import { trackByNodeId } from '../../model/screen-index';
import { NodeHostComponent } from '../node-host.component';
import { NodeRenderer, RenderMode } from '../node-renderer';
import { childLayoutStyles } from './child-layout';

@Component({
  selector: 'tem-screen-container',
  standalone: true,
  imports: [CommonModule, NodeHostComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="tem-screen">
      @for (child of children(); track trackBy(0, child)) {
        <div class="tem-screen__child" [ngStyle]="layoutOf(child)">
          <tem-node-host [node]="child" [form]="form()" [mode]="mode()" />
        </div>
      }
    </div>
  `,
  styleUrl: './screen.renderer.scss'
})
export class ScreenContainerRenderer implements NodeRenderer<'screen'> {

  readonly node = input.required<ScreenNode<'screen'>>();
  readonly form = input<FormGroup | null>(null);
  readonly mode = input<RenderMode>('view');

  readonly trackBy = trackByNodeId;

  readonly children = computed<readonly ScreenNode[]>(() => this.node().children ?? []);

  layoutOf(child: ScreenNode): Readonly<Record<string, string>> {
    return childLayoutStyles(child);
  }
}
